<template>
  <div class="svoi-label" :class="classes" @click="$emit('click')">
    <SvoiIcon v-if="iconLeft" class="icon-left" :icon="iconLeft" :size="iconSize" />
    <slot>{{ name }}</slot>
    <SvoiIcon v-if="iconRight" class="icon-right" :icon="iconRight" :size="iconSize" />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue-demi'
import { SvoiIcon } from '@svoi-ui/components/icon'
import { Themes, ThemesEnum, Sizes, SizesEnum } from '@svoi-ui/interfaces/label'
import { SizesEnum as IconSizesEnum } from '@svoi-ui/interfaces/icon'
import { isString } from '@svoi-ui/shared/utils/guards'

export default defineComponent({
  name: 'SvoiLabel',
  components: { SvoiIcon },
  props: {
    name: {
      type: String,
      required: true
    },
    theme: {
      type: String as PropType<Themes | string>,
      default: ThemesEnum.qiwi,
      validator(value: unknown) {
        return (
          isString(value) &&
          [
            ThemesEnum.qiwi.toString(),
            ThemesEnum.qiwiLight.toString(),
            ThemesEnum.banana.toString(),
            ThemesEnum.chilli.toString(),
            ThemesEnum.potato.toString(),
            ThemesEnum.figs.toString()
          ].includes(value)
        )
      }
    },
    iconLeft: {
      type: String,
      default: ''
    },
    iconRight: {
      type: String,
      default: ''
    },
    size: {
      type: String as PropType<Sizes | string>,
      default: SizesEnum.m,
      validator: (value: unknown) => {
        return isString(value) && [SizesEnum.m.toString(), SizesEnum.l.toString()].includes(value)
      }
    }
  },
  emits: ['click'],
  setup(props) {
    const classes = computed(() => {
      return {
        [`-theme-${props.theme}`]: true,
        [`-size-${props.size}`]: true
      }
    })
    const iconSize = computed(() => (props.size === SizesEnum.m ? IconSizesEnum.xs : IconSizesEnum.s))

    return { classes, iconSize }
  }
})
</script>

<style lang="scss" scoped>
@use '@svoi-ui/assets/scss/components/label.scss';
</style>
